import { render, staticRenderFns } from "./pickup-filters-list.vue?vue&type=template&id=b418d566&"
import script from "./pickup-filters-list.vue?vue&type=script&lang=js&"
export * from "./pickup-filters-list.vue?vue&type=script&lang=js&"
import style0 from "./pickup-filters-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b418d566')) {
      api.createRecord('b418d566', component.options)
    } else {
      api.reload('b418d566', component.options)
    }
    module.hot.accept("./pickup-filters-list.vue?vue&type=template&id=b418d566&", function () {
      api.rerender('b418d566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/pickup-filters/pickup-filters-list.vue"
export default component.exports